export { default } from './CommentChildFormRWrapper';



// WEBPACK FOOTER //
// ./src/components/Comment/ReducerWrappers/CommentChildFormRWrapper/index.js